import { React, classNames } from '@digsup/core-ui';
import PropTypes from 'prop-types';
import { SpinIcon } from './SpinIcon';
import { styles } from './Spin.scss';

const cx = classNames.bind(styles);

export const Spin = ({ size, className, ...props }) => {
  const classes = cx(
    'c-spin',
    {
      [`c-spin--${size}`]: size,
    },
    className,
  );

  return (
    <div className={classes} {...props}>
      <div className="c-spin__preloader">
        <SpinIcon />
      </div>
      <div className="c-spin__smash" />
    </div>
  );
};

Spin.propTypes = {
  /**
   * Component size
   */
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  /**
   * Extend the classNames applied to the component
   */
  className: PropTypes.string,
};

Spin.defaultProps = {
  size: 'medium',
  className: '',
};
